import { IoClose } from "react-icons/io5"
import useTooltip from "../../customHooks/useTooltip"
import { Placement } from "../../types/types"
interface Props {
    placement: Placement
    margin: number
    children: React.ReactNode
    text: string
}
const Tooltipaction = ({margin,placement, text,children }:Props)=>{
    const {
        setReferenceElement,
        setPopperElement,
        setArrowElement,
        styles,
        attributes,
        isOpen,
        setisOpen
    } = useTooltip({placement, margin})
   return(
       <>
         <div 
            ref={setReferenceElement}
            className="c-tooltip-generate__content"
            onClick={()=>setisOpen(true)}
         >
            {children}
         </div>
         {
                isOpen && <div 
                ref={setPopperElement}
                style={styles.popper}
                {...attributes.popper} 
                className={`c-tooltip-generate  ${`c-tooltip-generate--active`}`}
            >
                <div className="c-tooltip-generate__overlay">
                    <div className="c-tooltip-generate__text">
                        {text}
                    </div>
                    <span className="c-tooltip-generate__clouse" onClick={()=>setisOpen(false)}><IoClose/></span>    
                </div>
                <div className="c-tooltip-generate__arrow" ref={setArrowElement} style={styles.arrow} />
             </div>
         }
         
       </>
    )
}
export default Tooltipaction